import React, {useRef, useState} from 'react';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Input} from "antd";
import {usePositionForm} from "../../../providers/PositionFormProvider";
import SpinLoader from "../../../components/SpinLoader";
import ReactDOM from "react-dom";


const PositionDeliverablesForm = props => {
    const formRef = useRef(null);

    const {
        formModel: position,
        isProjectUpdating
    } = usePositionForm();

    const [deliverableModal, setDeliverableModal] = useState(props.model ? TB.cloneDeep({...props.model}) : {
        name: '',
        description: '',
        target_delivery_at: position.isFixedRetainer() ? null : TB.moment(position.ended_at),
        is_adding: true
    })

    const onSubmit = async() => {
        let invalidFields = await formRef.current?.forceValidate();

        if (invalidFields) {
            const node = ReactDOM.findDOMNode(invalidFields);

            return;
        }

        return props.onSubmit(deliverableModal);
    }
    return (
        <div className="project-scope-form">
            <SpinLoader isLoading={isProjectUpdating}>
                <Form
                    ref={formRef}
                    model={deliverableModal}
                    onChange={(model) => {
                        let updated = {...deliverableModal}
                        for (let [key, value] of Object.entries(model)) {
                            updated = TB.set(updated, key, value)
                        }
                        setDeliverableModal(updated)
                    }}
                    onSubmit={null}
                    submitButton={false}
                    minimal
                    background="transparent"
                    fields={[]}
                    isDisabled={isProjectUpdating}>
                    <div className="flex flex-col items-stretch">

                        <div className="sm:flex flex-row gap-4">

                            <div className="basis-1/2">
                                <FormInputComponent
                                    fieldName="name"
                                    isReadOnly={!!deliverableModal.deliverable_id}
                                    label="Name"
                                    value={deliverableModal?.name || ''}
                                    type="antd-input"
                                    required={!deliverableModal.deliverable_id}
                                    disabled={isProjectUpdating}
                                    validateBeforeSubmit={false}
                                >
                                    <Input defaultValue={deliverableModal?.name || ''} bordered={!deliverableModal.deliverable_id}/>

                                </FormInputComponent>
                            </div>
                            {!position.isFixedRetainer() && (
                                <FormInputComponent
                                    fieldName="target_delivery_at"
                                    label={<span>Target Delivery Date <span className="italic text-xs">(Optional)</span></span>}
                                    value={deliverableModal?.target_delivery_at}
                                    type="date"
                                    required={false}
                                    disabled={isProjectUpdating}
                                    validateBeforeSubmit={false}
                                />
                            )}

                        </div>

                        {/* <FormInputComponent
                            fieldName="description"
                            label="Description"
                            isReadOnly={!!deliverableModal.deliverable_id}
                            value={deliverableModal?.description}
                            disabled={isProjectUpdating}
                            placeholder={"Describe your deliverable and list any requirements..."}
                            required={!deliverableModal.deliverable_id}
                            type="antd-input"
                            // tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                            maxLength={1000}
                            rows={3}
                            validation={{
                                rules: {maxLength: 1000},
                                errors: {
                                    maxLength: TB.trans('validation.max.string', {
                                        'attribute': 'description',
                                        'max': 1000
                                    })
                                }
                            }}>
                            <Input.TextArea
                                showCount={!deliverableModal.deliverable_id}
                                bordered={!deliverableModal.deliverable_id}
                                defaultValue={deliverableModal?.description || ''}
                                autoSize={{minRows: 3}} maxLength={1000} />

                        </FormInputComponent> */}
                        <FormInputComponent
                            fieldName="description"
                            label="Description"
                            isReadOnly={!!deliverableModal.deliverable_id}
                            value={deliverableModal?.description}
                            disabled={isProjectUpdating}
                            placeholder={"Describe your deliverable and list any requirements..."}
                            required={!deliverableModal.deliverable_id}
                            // type="antd-input"
                            // tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                            maxLength={5000}
                            rows={3}
                            validation={{
                                rules: {maxLength: 5000},
                                errors: {
                                    maxLength: TB.trans('validation.max.string', {
                                        'attribute': 'description',
                                        'max': 5000
                                    })
                                }
                            }}
                            type="editor"
                            tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                        />

                        <FormInputComponent
                            fieldName="notes"
                            label={<span>Additional Notes <span className="italic text-xs">(Optional)</span></span>}
                            value={deliverableModal?.notes}
                            placeholder={"Type any additional notes here..."}
                            disabled={isProjectUpdating}
                            required={false}
                            type="antd-input"
                            rows={3}
                            // tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                            maxLength={5000}
                            validation={{
                                rules: {maxLength: 5000},
                                errors: {
                                    maxLength: TB.trans('validation.max.string', {
                                        'attribute': 'notes',
                                        'max': 5000
                                    })
                                }
                            }}>

                            <Input.TextArea
                                showCount
                                defaultValue={deliverableModal?.notes || ''}
                                autoSize={{minRows: 3}} maxLength={1000} />

                        </FormInputComponent>

                    </div>

                    <div className="flex flex-row justify-end gap-3 py-4">
                        <button disabled={isProjectUpdating || props.isDisabled} type="button" onClick={props.onCancel}
                                className="btn btn-outline-dark btn-outline-white">
                            Cancel
                        </button>
                        <button disabled={isProjectUpdating || props.isDisabled}
                                type="button" onClick={() => onSubmit()} className="btn btn-primary">
                            {props.submitBtn || 'Update'}
                        </button>
                    </div>
                </Form>
            </SpinLoader>
        </div>

    );
};

PositionDeliverablesForm.propTypes = {};

export default PositionDeliverablesForm;